export default __webpack_public_path__ + "static/media/razao-social-modelo.4fbd4c2e.png";